module.exports = __webpack_public_path__ + "static/img/Zac-Laybutt.a9edde8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Zac-Laybutt.jpg
// module id = NKiZ
// module chunks = 0